module.exports = __webpack_public_path__ + "static/media/_Orderinstruktion.cc9885e5.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Citroneer/orderinstruktion/_Orderinstruktion.scss
// module id = 453
// module chunks = 0